__turbopack_context__.v({
  "container": "BenefitList-module__U2Phjq__container",
  "divider": "BenefitList-module__U2Phjq__divider",
  "item": "BenefitList-module__U2Phjq__item",
  "list": "BenefitList-module__U2Phjq__list",
  "title": "BenefitList-module__U2Phjq__title",
  "wrapper": "BenefitList-module__U2Phjq__wrapper",
});
